import React, { useContext } from "react";
import { WidgetProps } from "@rjsf/utils";
import { AuthContext } from "../../../../../../Authorization/AuthContext";
import { BuilderFieldWrapper } from "../../__styles__/SubmissionsBuilder";
import { SubmissionsBuilderContextInstance } from "../../context";
import { withStopPropagation } from "../../utils";
import FieldPreviewFooter from "./FieldPreviewFooter";

const BaseWidgetPreview = (
  props: WidgetProps & { widgetPreview: JSX.Element },
) => {
  const { fieldActionsPropsByPath, fieldContextsByName, selectedField } =
    useContext(SubmissionsBuilderContextInstance);
  const { account } = useContext(AuthContext);

  const { id, name } = props;
  const fieldContext = fieldContextsByName[id];

  if (!fieldContext) {
    return null;
  }

  const fieldProps = fieldActionsPropsByPath[fieldContext.fieldPath];

  if (!fieldProps) {
    return null;
  }

  const isSelected = selectedField?.name === name;

  return (
    <BuilderFieldWrapper
      onClick={withStopPropagation(fieldProps.selectField)}
      isSelected={isSelected}
    >
      <div style={{ marginBottom: "4px" }}>
        {React.cloneElement(props.widgetPreview, { isSubmissionBuilder: true })}
      </div>
      <FieldPreviewFooter
        fieldPath={fieldContext.fieldPath}
        {...fieldProps}
        userGroups={account?.userGroups ?? []}
      />
    </BuilderFieldWrapper>
  );
};

export default BaseWidgetPreview;
